export default "__VITE_ASSET__a4cece9e__"